
      /* =========================================
   2️⃣ Lazy Init Helper
========================================= */
      function lazyInit(el, callback) {
        if (!el) return;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                callback();
                observer.disconnect();
              }
            });
          },
          { rootMargin: '200px' }
        );

        observer.observe(el);
      }

      /* =========================================
   3️⃣ Init ALL Swipers
========================================= */
      function initAllSwipers() {
        /* ========= Product Tabs Slider ========= */
        document.querySelectorAll('.product_tabs .tab_slider_wrapper').forEach(function (swiperEl) {
          if (swiperEl.classList.contains('swiper-initialized')) return;

          lazyInit(swiperEl, function () {
            const track = swiperEl.querySelector('.swiper-wrapper');
            if (!track) return;

            let isScrolling = false;
            let startX = 0;
            const dragThreshold = 50;
            let ugcSwiper;

            function equalizeSlideHeights() {
              const slides = swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
              let maxHeight = 0;

              slides.forEach((slide) => {
                slide.style.height = 'auto';
                maxHeight = Math.max(maxHeight, slide.offsetHeight);
              });

              slides.forEach((slide) => {
                slide.style.height = maxHeight + 'px';
              });
            }

            ugcSwiper = new Swiper(swiperEl, {
              slidesPerView: 4,
              spaceBetween: 20,
              loop: true,
              speed: 500,
              keyboard: { enabled: true },

              navigation: {
                nextEl: swiperEl.querySelector('.swiper-button-next'),
                prevEl: swiperEl.querySelector('.swiper-button-prev'),
              },

              breakpoints: {
                0: { slidesPerView: 1, spaceBetween: 16 },
                601: { slidesPerView: 2, spaceBetween: 20 },
                1025: { slidesPerView: 3, spaceBetween: 20 },
                1441: { slidesPerView: 4, spaceBetween: 20 },
              },

              on: {
                init: equalizeSlideHeights,
                resize: equalizeSlideHeights,
              },
            });

            swiperEl.addEventListener(
              'wheel',
              function (e) {
                const shouldScroll = Math.abs(e.deltaX) > Math.abs(e.deltaY) || e.shiftKey;

                if (!shouldScroll) return;

                e.preventDefault();
                if (isScrolling) return;
                isScrolling = true;

                e.deltaX > 0 ? ugcSwiper.slideNext() : ugcSwiper.slidePrev();
                setTimeout(() => (isScrolling = false), 400);
              },
              { passive: false }
            );

            function getX(e) {
              return e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
            }

            function dragStart(e) {
              startX = getX(e);
              track.classList.add('dragging');
            }

            function dragEnd(e) {
              track.classList.remove('dragging');
              const delta = getX(e) - startX;
              if (Math.abs(delta) > dragThreshold) {
                delta > 0 ? ugcSwiper.slidePrev() : ugcSwiper.slideNext();
              }
            }

            track.addEventListener('mousedown', dragStart);
            track.addEventListener('mouseup', dragEnd);
            track.addEventListener('mouseleave', dragEnd);
            track.addEventListener('touchstart', dragStart);
            track.addEventListener('touchend', dragEnd);
          });
        });

        /* ========= Custom22 Slider (LAZY) ========= */
        const custom22 = document.querySelector('.custom22_slider');

        if (custom22 && !custom22.classList.contains('swiper-initialized')) {
          lazyInit(custom22, function () {
            const slides = custom22.querySelectorAll('.swiper-slide');
            const totalSlides = slides.length;

            const nextBtn = document.querySelector('.custom22-next');
            const prevBtn = document.querySelector('.custom22-prev');

            function getSlidesPerView() {
              const w = window.innerWidth;
              if (w >= 1000) return Math.min(4, totalSlides);
              if (w >= 600) return Math.min(2, totalSlides);
              return 1;
            }

            const slidesPerView = getSlidesPerView();
            const showArrows = totalSlides > slidesPerView;

            if (nextBtn) nextBtn.style.display = showArrows ? 'flex' : 'none';
            if (prevBtn) prevBtn.style.display = showArrows ? 'flex' : 'none';

            new Swiper(custom22, {
              slidesPerView,
              spaceBetween: 15,
              grabCursor: true,

              // 🔥 loop only if needed
              loop: totalSlides > slidesPerView && totalSlides <= 6,

              navigation: {
                nextEl: '.custom22-next',
                prevEl: '.custom22-prev',
              },

              autoplay: false, // 🔥 reduces TBT

              breakpoints: {
                0: { slidesPerView: 1 },
                600: { slidesPerView: Math.min(2, totalSlides) },
                1000: { slidesPerView: Math.min(4, totalSlides) },
              },
            });
          });
        }
      }

      /* =========================================
   4️⃣ Safe Init
========================================= */
      if (window.Swiper) {
        initAllSwipers();
      } else {
        document.addEventListener('swiper:loaded', initAllSwipers, { once: true });
      }